export default "__VITE_ASSET__B12NpvZB__"